function accountSeeMoreTrigger() {
 $(document).on("click", ".seeMoreTrigger", function() {
  $(this)
   .siblings(".seeMoreTriggered")
   .toggleClass("is-hided");
  if ($(this).text() == "See more") {
   $(this).text("Hide");
  } else {
   $(this).text("See more");
  }
 });
}